import {
	FETCH_BOTS, FETCH_BOTS_SUCCESS, FETCH_BOTS_FAILURE
} from '../actions/bots';

const INITIAL_STATE = { 
    data: [], error: null, loading: false
};

export default function(state = INITIAL_STATE, action) {
    let error;
    switch(action.type) {
        case FETCH_BOTS:// start fetching posts and set loading = true
            const newState = { ...state, data:[], error: null, loading: true };
            return  newState;
        case FETCH_BOTS_SUCCESS:// return list of posts and make loading = false
            return { ...state, data: action.payload, error:null, loading: false };
        case FETCH_BOTS_FAILURE:// return error and make loading = false
            error =  { message: 'There was an error fetching the bots.' };//2nd one is network or server down errors
            return { ...state, data: [], error: error, loading: false };

        default:
            return state;

    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/reducer-bots.js